import {
  $BonusLevel,
  $ModuleArea,
  BonusLevel,
  ModuleArea,
} from '@suntex.fim/enums';

import { NodeModel } from '../../../types';

const moduleAreaDesc = $ModuleArea.describe(ModuleArea.BonusGames);

export const bonusNode: NodeModel = {
  tag: moduleAreaDesc.slug,
  info: {
    title: moduleAreaDesc.label,
  },
  label: {
    aria: moduleAreaDesc.label,
    class: 'MainLabel',
    frame: 4,
  },
  color: moduleAreaDesc.color,
  layout: 'levels',
  children: [
    {
      tag: $BonusLevel.describe(BonusLevel.Bonus1).slug,
      label: {
        aria: $BonusLevel.describe(BonusLevel.Bonus1).label,
      },
      color: $BonusLevel.describe(BonusLevel.Bonus1).color,
      children: [
        {
          moduleSlug: 'ten-wheels',
          icon: 'games/ten-wheels',
          label: 'Ten Wheels',
          color: 0x42d9e4,
        },
        {
          moduleSlug: 'first-in-tens-add',
          icon: 'games/first-in-tens-add',
          label: 'First in Tens - Add',
          color: 0x99cc00,
        },
        {
          moduleSlug: 'first-in-tens-sub',
          icon: 'games/first-in-tens-sub',
          label: 'First in Tens - Subtract',
          color: 0x663399,
        },
        {
          tag: 'mol',
          icon: 'games/mol',
          label: 'More or Less',
          layout: 'clock',
          color: 0x5ea8e4,
          children: [
            {
              moduleSlug: 'mol',
              moduleVariant: 0,
              icon: 'games/mol-lvl1',
              label: 'More or Less\nLevel 1',
            },
            {
              moduleSlug: 'mol',
              moduleVariant: 1,
              icon: 'games/mol-lvl2',
              label: 'More or Less\nLevel 2',
            },
          ],
        },
        {
          moduleSlug: 'shape-shuffle',
          icon: 'games/shape-shuffle',
          label: 'Shape Shuffle',
          color: 0x8c1db4,
        },
        {
          moduleSlug: 'link-n-lock-as',
          icon: 'games/link-n-lock-as',
          label: "Link 'N Lock\nAdd/Subtract",
          color: 0xef2b63,
        },
        {
          moduleSlug: 'early-algebra-tiles',
          icon: 'games/early-algebra-tiles',
          label: 'Early Algebra\nTiles',
          color: 0xff66e3,
        },
      ],
    },
    {
      tag: $BonusLevel.describe(BonusLevel.Bonus2).slug,
      label: {
        aria: $BonusLevel.describe(BonusLevel.Bonus2).label,
      },
      color: $BonusLevel.describe(BonusLevel.Bonus2).color,
      children: [
        {
          tag: 'deep-seaquence',
          icon: 'games/deep-seaquence',
          label: 'Deep Sea-quence',
          layout: 'clock',
          color: 0x003399,
          children: [
            {
              moduleSlug: 'deep-seaquence',
              moduleVariant: 0,
              icon: 'games/deep-seaquence-lvl1',
              label: 'Deep Seaquence\nLevel 1',
            },
            {
              moduleSlug: 'deep-seaquence',
              moduleVariant: 1,
              icon: 'games/deep-seaquence-lvl2',
              label: 'Deep Seaquence\nLevel 2',
            },
          ],
        },
        {
          moduleSlug: 'number-circles',
          icon: 'games/number-circles',
          label: 'Number Circles',
          color: 0xff8000,
        },
        {
          tag: 'grand-slam-add-sub',
          icon: 'games/grand-slam-add-sub',
          label: 'Grand Slam\nAdd/Subtract',
          layout: 'clock',
          color: 0xb29aff,
          children: [
            {
              moduleSlug: 'grand-slam-add-sub',
              moduleVariant: 0,
              icon: 'games/grand-slam-add-sub',
              label: 'Grand Slam\nAdd/Subtract',
            },
            {
              moduleSlug: 'grand-slam-add-sub',
              moduleVariant: 1,
              icon: 'games/grand-slam-add-sub',
              label: 'Grand Slam A/S\n5 Digit',
            },
            {
              moduleSlug: 'grand-slam-add-sub',
              moduleVariant: 2,
              icon: 'games/grand-slam-add-sub',
              label: 'Grand Slam A/S\n6 Digit',
            },
          ],
        },
        {
          moduleSlug: 'first-to-twenty-add',
          icon: 'games/first-to-twenty-add',
          label: 'First to Twenty\nAdd',
          color: 0xcc0033,
        },
        {
          moduleSlug: 'first-to-twenty-sub',
          icon: 'games/first-to-twenty-sub',
          label: 'First to Twenty\nSubtract',
          color: 0x3366cc,
        },
        {
          moduleSlug: 'speed-shuffle',
          icon: 'games/speed-shuffle',
          label: 'Speed Shuffle',
          color: 0x8f5ae9,
        },
        {
          moduleSlug: 'touchdown-100-add',
          icon: 'games/touchdown-100-add',
          label: 'Go To 100\nAdd',
          color: 0x669900,
        },
        {
          moduleSlug: 'touchdown-100-sub',
          icon: 'games/touchdown-100-sub',
          label: 'Go To 100\nSubtract',
          color: 0x330066,
        },
        {
          moduleSlug: 'geometry-tiles',
          icon: 'games/geometry-tiles',
          label: 'Geometry\nTiles',
          color: 0xb366ff,
        },
      ],
    },
    {
      tag: $BonusLevel.describe(BonusLevel.Bonus3).slug,
      label: {
        aria: $BonusLevel.describe(BonusLevel.Bonus3).label,
      },
      color: $BonusLevel.describe(BonusLevel.Bonus3).color,
      children: [
        {
          moduleSlug: 'factor-wheels',
          icon: 'games/factor-wheels',
          label: 'Factor Wheels',
          color: 0xb7d554,
        },
        {
          moduleSlug: 'grand-slam-mul-div',
          icon: 'games/grand-slam-mul-div',
          label: 'Grand Slam\nMultiply/Divide',
          color: 0xff6633,
        },
        {
          moduleSlug: 'skip-game',
          icon: 'games/skip-game',
          label: 'Skip Game',
          color: 0x696cfe,
        },
        {
          moduleSlug: 'decimals-mol',
          icon: 'games/decimals-mol',
          label: 'Decimals\nMore or Less',
          color: 0x0033ff,
        },
        {
          moduleSlug: 'xyz-shuffle',
          icon: 'games/xyz-shuffle',
          label: 'XYZ Shuffle',
          color: 0xbc66ed,
        },
        {
          tag: 'estimation',
          icon: 'games/estimation',
          label: 'Estimation',
          layout: 'clock',
          color: 0x00c4cc,
          children: [
            {
              moduleSlug: 'estimation',
              moduleVariant: 0,
              icon: 'games/estimation-newb',
              label: 'Estimation\nNewb',
            },
            {
              moduleSlug: 'estimation',
              moduleVariant: 1,
              icon: 'games/estimation-epic',
              label: 'Estimation\nEpic',
            },
          ],
        },
        {
          moduleSlug: 'link-n-lock-md',
          icon: 'games/link-n-lock-md',
          label: "Link 'N Lock\nMultiply/Divide",
          color: 0x006059,
        },
        {
          moduleSlug: 'equivalent-fraction-tiles',
          icon: 'games/equivalent-fraction-tiles',
          label: 'Equivalent\nFraction Tiles',
          color: 0xff9900,
        },
        {
          moduleSlug: 'vif-tiles',
          icon: 'games/vif-tiles',
          label: 'VIFs Tiles',
          color: 0x00c8ff,
        },
        {
          moduleSlug: 'elementary-algebra-tiles',
          icon: 'games/elementary-algebra-tiles',
          label: 'Elementary\nAlgebra Tiles',
          color: 0xff8dff,
        },
        {
          moduleSlug: 'ten-wheels-elite',
          icon: 'games/ten-wheels-elite',
          label: 'Ten Wheels\nElite',
          color: 0xff3366,
        },
      ],
    },
    {
      tag: $BonusLevel.describe(BonusLevel.Bonus4).slug,
      label: {
        aria: $BonusLevel.describe(BonusLevel.Bonus4).label,
      },
      color: $BonusLevel.describe(BonusLevel.Bonus4).color,
      children: [
        {
          moduleSlug: 'undo-fractions',
          icon: 'games/undo-fractions',
          label: 'Fractions\nUndo',
          color: 0xff9900,
        },
        {
          moduleSlug: '24-wheels',
          icon: 'games/24-wheels',
          label: '24 Wheels',
          color: 0xffe558,
        },
        {
          moduleSlug: 'monus-path',
          icon: 'games/monus-path',
          label: "Monu's Path",
          color: 0xcc3333,
        },
        {
          tag: 'the-hex-factor',
          icon: 'games/the-hex-factor',
          label: 'The Hex Factor',
          layout: 'clock',
          color: 0x62b0b1,
          children: [
            {
              moduleSlug: 'the-hex-factor',
              moduleVariant: 0,
              icon: 'games/hex-factor-lvl1',
              label: 'Hex Factor\nLevel 1',
            },
            {
              moduleSlug: 'the-hex-factor',
              moduleVariant: 1,
              icon: 'games/hex-factor-lvl2',
              label: 'Hex Factor\nLevel 2',
            },
          ],
        },
        {
          moduleSlug: 'fractions-mol',
          icon: 'games/fractions-mol',
          label: 'Fractions\nMore or Less',
          color: 0x77a7d3,
        },
        {
          moduleSlug: 'pundis-puzzle',
          icon: 'games/pundis-puzzle',
          label: "Pundi's Puzzle",
          color: 0x9ad142,
        },
        {
          moduleSlug: 'misfits-37',
          icon: 'games/misfits-37',
          label: 'Misfits 3x7',
          color: 0xff3333,
        },
        {
          moduleSlug: 'jennies-jewels',
          icon: 'games/jennies-jewels',
          label: "Jennie's Jewels",
          color: 0x33dbe4,
        },
      ],
    },
    {
      tag: $BonusLevel.describe(BonusLevel.Bonus5).slug,
      label: {
        aria: $BonusLevel.describe(BonusLevel.Bonus5).label,
      },
      color: $BonusLevel.describe(BonusLevel.Bonus5).color,
      children: [
        {
          moduleSlug: 'fraction-wheels',
          icon: 'games/fraction-wheels',
          label: 'Fraction Wheels',
          color: 0xff5dbb,
        },
        {
          moduleSlug: 'epic-circles',
          icon: 'games/epic-circles',
          label: 'Epic Circles',
          color: 0x50cccc,
        },
        {
          moduleSlug: 'pattern-puzzle',
          icon: 'games/pattern-puzzle',
          label: 'Pattern Puzzle',
          color: 0x0d228c,
        },
        {
          tag: 'equivalents',
          icon: 'games/equivalents',
          label: 'Equivalents',
          layout: 'clock',
          color: 0x6b4525,
          children: [
            {
              moduleSlug: 'equivalents',
              moduleVariant: 0,
              icon: 'games/equivalents-lvl1',
              label: 'Equivalents\nLevel 1',
            },
            {
              moduleSlug: 'equivalents',
              moduleVariant: 1,
              icon: 'games/equivalents-lvl2',
              label: 'Equivalents\nLevel 2',
            },
          ],
        },
        {
          moduleSlug: 'grand-slam-integers',
          icon: 'games/grand-slam-integers',
          label: 'Grand Slam\nIntegers',
          color: 0xff6666,
        },
        {
          moduleSlug: 'rps',
          icon: 'games/rps',
          label: 'RPS Chess',
          color: 0x77aadd,
        },
        {
          moduleSlug: '3-moves-to-0',
          icon: 'games/3-moves-to-0',
          label: '3 Moves To 0',
          color: 0x00cc0b,
        },
      ],
    },
    {
      tag: $BonusLevel.describe(BonusLevel.Bonus6).slug,
      label: {
        aria: $BonusLevel.describe(BonusLevel.Bonus6).label,
      },
      color: $BonusLevel.describe(BonusLevel.Bonus6).color,
      children: [
        {
          moduleSlug: 'monujis-path',
          icon: 'games/monujis-path',
          label: "Monuji's Path",
          color: 0x662796,
        },
        {
          moduleSlug: 'pattern-power',
          icon: 'games/pattern-power',
          label: 'Pattern Power',
          color: 0x0284fe,
        },
        {
          tag: 'estimation-dec',
          icon: 'games/estimation-dec',
          label: 'Estimation\nDecimals',
          layout: 'clock',
          color: 0x9966ff,
          children: [
            {
              moduleSlug: 'estimation-dec',
              moduleVariant: 0,
              icon: 'games/estimation-dec-newb',
              label: 'Estimation Decimals\nNewb',
            },
            {
              moduleSlug: 'estimation-dec',
              moduleVariant: 1,
              icon: 'games/estimation-dec-epic',
              label: 'Estimation Decimals\nEpic',
            },
          ],
        },
        {
          moduleSlug: 'misfits-37-num',
          icon: 'games/misfits-37-num',
          label: 'Misfits 3x7\nNumbers',
          color: 0x9999ff,
        },
        {
          tag: 'grand-slam-dec',
          icon: 'games/grand-slam-dec',
          label: 'Grand Slam\nDecimals',
          color: 0x0099cc,
          children: [
            {
              moduleSlug: 'grand-slam-dec-add-sub',
              icon: 'games/grand-slam-dec-add-sub',
              label: 'Add/Subtract',
              filtered: {
                label: 'Grand Slam\nDecimals - Add/Subtract',
              },
              color: 0xb29aff,
            },
            {
              moduleSlug: 'grand-slam-dec-mul-div',
              icon: 'games/grand-slam-dec-mul-div',
              label: 'Multiply/Divide',
              filtered: {
                label: 'Grand Slam\nDecimals - Multiply/Divide',
              },
              color: 0xff6633,
            },
            {
              moduleSlug: 'grand-slam-dec-all',
              icon: 'games/grand-slam-dec-all',
              label: 'All Operations',
              filtered: {
                label: 'Grand Slam\nDecimals - All Operations',
              },
              color: 0xffcc33,
            },
          ],
        },
        {
          moduleSlug: 'decimal-tiles',
          icon: 'games/decimal-tiles',
          label: 'Decimal\nTiles',
          color: 0xffa700,
        },
        {
          moduleSlug: 'integer-tiles',
          icon: 'games/integer-tiles',
          label: 'Integer\nTiles',
          color: 0x009b89,
        },
        {
          moduleSlug: 'exponent-tiles',
          icon: 'games/exponent-tiles',
          label: 'Exponent\nTiles',
          color: 0xff0000,
        },
      ],
    },
    {
      tag: $BonusLevel.describe(BonusLevel.Bonus7).slug,
      label: {
        aria: $BonusLevel.describe(BonusLevel.Bonus7).label,
      },
      color: $BonusLevel.describe(BonusLevel.Bonus7).color,
      children: [
        {
          moduleSlug: 'xtreme-algebra',
          icon: 'games/xtreme-algebra',
          label: 'Xtreme Algebra',
          color: 0x185021,
        },
        {
          moduleSlug: 'algebra-mol',
          icon: 'games/algebra-mol',
          label: 'Algebra\nMore or Less',
          color: 0x0e64f6,
        },
        {
          tag: 'grand-slam-frc',
          icon: 'games/grand-slam-frc',
          label: 'Grand Slam\nFractions',
          color: 0xff6600,
          children: [
            {
              moduleSlug: 'grand-slam-frc-add-sub',
              icon: 'games/grand-slam-frc-add-sub',
              label: 'Add/Subtract',
              filtered: {
                label: 'Grand Slam\nFractions - Add/Subtract',
              },
              color: 0xb29aff,
            },
            {
              moduleSlug: 'grand-slam-frc-mul-div',
              icon: 'games/grand-slam-frc-mul-div',
              label: 'Multiply/Divide',
              filtered: {
                label: 'Grand Slam\nFractions - Multiply/Divide',
              },
              color: 0xff6633,
            },
            {
              moduleSlug: 'grand-slam-frc-all',
              icon: 'games/grand-slam-frc-all',
              label: 'All Operations',
              filtered: {
                label: 'Grand Slam\nFractions - All Operations',
              },
              color: 0xffcc33,
            },
          ],
        },
        {
          moduleSlug: 'order-of-operations-tiles',
          icon: 'games/order-of-operations-tiles',
          label: 'Order of\nOperations Tiles',
          color: 0x9966e3,
        },
        {
          moduleSlug: 'link-n-lock-frc',
          icon: 'games/link-n-lock-frc',
          label: "Link 'N Lock\nFractions",
          color: 0x1e0000,
        },
        {
          moduleSlug: 'fraction-tiles',
          icon: 'games/fraction-tiles',
          label: 'Fraction\nTiles',
          color: 0xffba00,
        },
        {
          moduleSlug: 'algebra-tiles',
          icon: 'games/algebra-tiles',
          label: 'Algebra\nTiles',
          color: 0xe333a9,
        },
      ],
    },
    {
      tag: $BonusLevel.describe(BonusLevel.Bonus8).slug,
      label: {
        aria: $BonusLevel.describe(BonusLevel.Bonus8).label,
      },
      color: $BonusLevel.describe(BonusLevel.Bonus8).color,
      children: [
        {
          moduleSlug: 'rps-master',
          icon: 'games/rps-master',
          label: 'Master RPS\nChess',
          color: 0x001166,
        },
        {
          moduleSlug: 'into-the-vortex',
          icon: 'games/into-the-vortex',
          label: 'Into the Vortex',
          color: 0xaa5b04,
        },
        {
          moduleSlug: 'grand-slam-alg',
          icon: 'games/grand-slam-alg',
          label: 'Grand Slam\nAlgebra',
          color: 0x00b93c,
        },
        {
          moduleSlug: '3-moves-to-0-quantum',
          icon: 'games/3-moves-to-0-quantum',
          label: 'Quantum Zeroes',
          color: 0xff6600,
        },
        {
          moduleSlug: 'quantum-algebra',
          icon: 'games/quantum-algebra',
          label: 'Quantum Algebra',
          color: 0x33dbe4,
        },
      ],
    },
  ],
};
